// Added for typing effect for provided texts

import React, { useEffect, useState } from 'react';
import { SxProps, Typography } from '@mui/material';

interface TypingEffectProps {
    words: string[];
    typographySX?: SxProps;
    varient?: any;
}
const TypingEffect: React.FC<TypingEffectProps> = (props) => {
    const {words, typographySX, varient} = props;
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    let typingSpeed = isDeleting ? 70 : 150;
  
    if (words.length === 1 && text === currentWord) {
      return; // Stop typing/deleting if only one word and it's fully typed
    }
  
    const typeTimeout = setTimeout(() => {
      const updatedText = isDeleting
        ? currentWord.substring(0, text.length - 1)
        : currentWord.substring(0, text.length + 1);
      setText(updatedText);
  
      if (!isDeleting && updatedText === currentWord) {
        if (words.length > 1) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }, typingSpeed);
  
    return () => clearTimeout(typeTimeout);
  }, [text, isDeleting, currentWordIndex, words]);
  

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setBlink((prev) => !prev);
    }, 500);
    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <Typography variant={varient} sx={typographySX}>
      {text}
      <span style={{ opacity: blink ? 1 : 0, color: "#FFFFFF" }}>|</span>
    </Typography>
  );
};

export default TypingEffect;
